//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Shared/Button.vue'
import DividerWithText from '@/components/Shared/Dividers/DividerWithText.vue'
export default {
  components: {
    Button,
    DividerWithText,
  },
}
